import { useState, useRef } from 'react'
import axios from 'axios'
import InputField from './fields/InputField'
import InputSelect from './fields/InputSelect'
import ErrorNotification from './ErrorNotification'
import isValidDomain from 'is-valid-domain'
import RenderResults from './RenderResults'
import RenderFinalScore from './RenderFinalScore'
import ListPlaceholder from './loaders/ListPlaceholder'
// import localResults from './response.json'
import "bootstrap/js/dist/collapse"
import "bootstrap/js/dist/modal"
import PhoneInputField from './fields/PhoneInputField'
import CalendlyCTA from './CalendlyCTA'
// import IconArrow from './icons/IconArrow'
import CalendlyModal from './CalendlyModal'
import html2pdf from 'html2pdf.js';

function WaveAccessibilityTest(props) {
  const { wave_api_key, recaptcha_site_key } = props
  const [loading, setLoading] = useState(false);
  const [hideFormOnSubmit, setHideFormOnSubmit] = useState(false)
  const [newResults, setNewResults] = useState('');
  const [finalScore, setFinalScore] = useState(null);
  const [error, setError] = useState('');
  const submitRef = useRef(null);
  const submittedUrl = useRef(null);
  const [errors, setErrors] = useState({});
  const itiRef = useRef(null);
  const [renderForPDF, setRenderForPDF] = useState(false);

  const t = (k) => (window.accessI18n?.[k] ?? k);

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    url: '',
    agencyOrFreelancer: '',
    phone: '',
    help: '',
  });

  const ifIsUrl = (string) => {
    return (/(http(s?)):\/\//i.test(string)) ? true : false
  }

  const isValidUrl = (string) => {
    try {
      new URL(string);
      return true;
    } catch (_) {
      return false;
    }
  }

  const validateField = (name, value) => {
    let fieldErrors = { ...errors };

    switch (name) {
      // case 'firstName':
      //   fieldErrors.firstName = value ? '' : 'Please fill out this field.';
      //   break;
      // case 'lastName':
      //   fieldErrors.lastName = value ? '' : 'Please fill out this field.';
      //   break;
      // case 'agencyOrFreelancer':
      //   fieldErrors.agencyOrFreelancer = value ? '' : 'Please fill out this field.';
      //   break;
      // case 'email':
      //   if (!value) {
      //     fieldErrors.email = 'Please fill out this field.';
      //   } else if (!/\S+@\S+\.\S+/.test(value)) {
      //     fieldErrors.email = 'Email is invalid';
      //   } else {
      //     fieldErrors.email = '';
      //   }
      //   break;
      case 'url':
        if (!value) {
          fieldErrors.url = t('Please enter a valid URL or domain name');
        } else if (ifIsUrl(value)) {
          if (!isValidUrl(value)) {
            fieldErrors.url = t('Please enter a valid URL or domain name');
          } else {
            fieldErrors.url = '';
          }
        } else {
          if (!isValidDomain(value)) {
            fieldErrors.url = t('Please enter a valid URL or domain name');
          } else {
            fieldErrors.url = '';
          }
        }
        break;
      default:
        break;
    }

    setErrors(fieldErrors);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    console.log(name)
    console.log(value)

    // Validacija u realnom vremenu
    validateField(name, value);
  };

  const validateForm = () => {
    let formErrors = {};
    let isValid = true;
    const iti = itiRef.current;

    // if (!formData.firstName) {
    //   formErrors.firstName = 'Please fill out this field.';
    //   isValid = false;
    // }
    // if (!formData.lastName) {
    //   formErrors.lastName = 'Please fill out this field.';
    //   isValid = false;
    // }
    // if (!formData.agencyOrFreelancer) {
    //   formErrors.agencyOrFreelancer = 'Please fill out this field.';
    //   isValid = false;
    // }
    // if (!formData.email) {
    //   formErrors.email = 'Please fill out this field.';
    //   isValid = false;
    // } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
    //   formErrors.email = 'Please enter a valid email address';
    //   isValid = false;
    // }
    // if (!iti.telInput.value) {
    //   formErrors.phone = 'Please fill out this field.';
    //   isValid = false;
    // } else if (!iti.isValidNumberPrecise()) {
    //   const errorCode = iti.getValidationError();
    //   const errorMap = [
    //     "The number is not valid.",
    //     "Invalid country code.",
    //     "Too short.",
    //     "Too long.",
    //     "The number is not valid."
    //   ];
    //   formErrors.phone = errorMap[errorCode] || 'Invalid phone number';
    //   isValid = false;
    // }
    if (!formData.url) {
      formErrors.url = t('Please enter a valid URL or domain name');
      isValid = false;
    } else if (ifIsUrl(formData.url)) {
      if (!isValidUrl(formData.url)) {
        formErrors.url = t('Please enter a valid URL or domain name');
        isValid = false;
      }
    } else {
      if (!isValidDomain(formData.url)) {
        formErrors.url = t('Please enter a valid URL or domain name');
        isValid = false;
      }
    }

    // Prevent retesting the same URL.
    if (submittedUrl.current.value == formData.url) {
      setError('You have already tested the selected URL')
      isValid = false;
    }

    setErrors(formErrors);
    return isValid;
  };

  const handleSubmit = async (event) => {
    event.preventDefault()
    const iti = itiRef.current;

    if (!validateForm()) {
      return;
    }

    // console.log(formData)
    // console.log(iti)

    let cf7_id = document.getElementById('accessibility-test').getAttribute('data-cf7_id')

    // Prevent double click with submitRef.
    if (submitRef.current && !submitRef.current.disabled) {
      submitRef.current.disabled = true

      setHideFormOnSubmit(true)
      setLoading(true)

      let urlOrDomain
      if (ifIsUrl(formData.url)) {
        urlOrDomain = formData.url
      } else {
        urlOrDomain = 'https://' + formData.url
      }

      const apiUrl = `https://wave.webaim.org/api/request?key=${wave_api_key}&reporttype=4&url=${encodeURIComponent(urlOrDomain)}`;

      fetchApiResponse(apiUrl)
        .then(response => {
          // console.log(response)
          calcPageScore(response)
          fetchPageContent(urlOrDomain, response)
          // submitRef.current.disabled = false
          // submittedUrl.current.value = url
        })
        .then((data) => {
          // console.log(data)
          cf7SendEmail(cf7_id, urlOrDomain, formData.email, formData.firstName, formData.lastName, iti.getNumber(), formData.agencyOrFreelancer, formData.help)
          setLoading(false)
        })
    }
  };

  const fetchApiResponse = async (url) => {
    try {
      const response = await fetch(url);

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();

      return data
    } catch (error) {
      setError('An error occurred while sending the request. Please try again later.');
      console.error('There has been a problem with your fetch operation:', error);
    }
  }

  function safeQuerySelector(doc, selector) {
    try {
      const norm = selector.toUpperCase();
      const bodyIndex = norm.indexOf("BODY");

      // Trim only if there is a stupid HEAD + BODY chain
      if (bodyIndex > -1 && selector.includes("HEAD") && selector.includes("+")) {
        const sliced = selector.slice(bodyIndex);
        const cleaned = sliced.replace(/^BODY\\s*>?\\s*/i, 'body > ');
        selector = cleaned;
        // console.warn(`🧹 Selector trimmed to start from body: "${selector}"`);
      }

      const el = doc.querySelector(selector);
      return el ? el.outerHTML : null;

    } catch (err) {
      // console.warn(`❌ Invalid selector (caught): "${selector}"`, err);
      return null;
    }
  }

  const fetchPageContent = async (url, wave_api_response) => {
    console.log('Fetching page content for URL:', url);
    console.log('Wave API Response:', wave_api_response);
    try {
      const data = new FormData();
      data.append('action', 'handle_ajax_request');
      data.append('nonce', accessibility_test_data.nonce_accessibility_test);
      data.append('url', url);

      fetch(accessibility_test_data.ajax_url, {
        method: 'POST',
        body: data,
      })
        .then((ajax_response) => {
          if (!ajax_response.ok) {
            throw new Error(`HTTP error! Status: ${ajax_response.status}`);
          }
          return ajax_response.text();
        })
        .then((data) => {
          if (!data.includes('<html')) {
            console.warn('❌ Likely blocked by bot protection or JS-only rendering site');
            const doc = document.implementation.createHTMLDocument('');
            doc.body.innerHTML = `
              <div>
                <p>⚠️ Content could not be loaded. This website likely uses JavaScript-only rendering or bot protection.</p>
              </div>
            `;
            filterResultsAfterResponse(wave_api_response, doc, true);
            return;
          }

          const parser = new DOMParser();
          const doc = parser.parseFromString(data, 'text/html');
          filterResultsAfterResponse(wave_api_response, doc, false);
        })
        .catch((error) => {
          console.error('Error loading HTML:', error);
        });
    } catch (error) {
      console.error('Error in fetchPageContent:', error);
    }
  };

  const filterResultsAfterResponse = async (response_data, formated_document, isBlocked = false) => {
    Object.keys(response_data.categories).forEach((category) => {
      const categoryData = response_data.categories[category];

      Object.values(categoryData.items).forEach((item) => {
        let new_selectors = [];

        if (Array.isArray(item.selectors)) {
          item.selectors.forEach((selector) => {
            if (typeof selector === 'string' && selector.trim() !== '') {
              const result = safeQuerySelector(formated_document, selector);
              new_selectors.push(result);
            } else {
              new_selectors.push(null);
            }
          });
        }

        const allFailed = new_selectors.every((sel) => sel === null);

        if (allFailed) {
          const fallbackMessage = `We detected an issue (${item.description}), but couldn’t locate the exact element.
            This might be due to dynamic content, or strict selectors (like :first-child +).`;
          item.new_selectors = [fallbackMessage];
        } else {
          item.new_selectors = new_selectors.filter(Boolean);
        }
      });
    });

    if (isBlocked) {
      response_data.fallback_notice =
        '⚠️ This website may block bot access or uses JavaScript-only rendering. Some results may be incomplete.';
    }

    setNewResults(response_data);
  };

  const calcPageScore = async (response) => {
    const categories = response.categories
    const statistics = response.statistics
    let count_categories = 0

    Object.values(categories).map((category) => {
      console.log(category)

      let cat_description = category.description

      if (cat_description == "Errors" || cat_description == "Contrast Errors" || cat_description == "Alerts") {
        count_categories += category.count
      }
    })

    let calc_percentage = Math.round((count_categories / statistics.allitemcount) * 100)

    let final_score = 100 - calc_percentage

    setFinalScore(final_score)
  }

  const cf7SendEmail = async (cf7_id, url, email, firstName, lastName, phone, agencyOrFreelancer, help) => {
    let lead_source_value = 'Regular - Accessibility Test'
    // Add Landing - Accessibility Test on these page
    let ls_diff_values_on = [
      13464,
      13990,
      13897
    ]

    if (ls_diff_values_on.includes(parseInt(accessibility_test_data.current_page_id))) {
      lead_source_value = 'Landing - Accessibility Test'
    }

    const body = new FormData();
    body.set("domain", url);
    body.set("email-882", email);
    body.set("first-name", firstName);
    body.set("last-name", lastName);
    body.set("phone-number", phone);
    body.set("agency-or-freelancer", agencyOrFreelancer);
    body.set("lead_source", lead_source_value);
    body.set("help", help);
    body.set('_wpcf7_unit_tag', 'wpcf7-f' + cf7_id)

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const cf7_post_url = accessibility_test_data.site_url + '/wp-json/contact-form-7/v1/contact-forms/' + cf7_id + '/feedback/';

    // window.grecaptcha.ready(() => {
    //   console.log(recaptcha_site_key)
    //   window.grecaptcha.execute(recaptcha_site_key, { action: 'submit' }).then((token) => {
    //     body.set('_wpcf7_recaptcha_response', token); // Add reCAPTCHA token in request

    axios.post(cf7_post_url, body)
      .then(response => response.data)
      .then(data => {
        // console.log(data)
        if (data.invalid_fields.length == 0) {
          // setLoading(false)
          // Reset form data
          // setFormData({
          //   firstName: '',
          //   lastName: '',
          //   email: '',
          //   url: '',
          //   phone: '',
          // });
        }
      })
      .catch((error) => {
        console.log(error)
      })
    // })
    // })
  }

  const handleDownloadPDF = () => {
    const element = document.getElementById("accessibility-test-results");
    if (!element) return;

    setRenderForPDF(true);

    // Wait for React to re-render the results in PDF mode (expanded items,
    // summary on top, no Calendly CTA) before html2canvas captures the DOM.
    setTimeout(() => {
      html2pdf()
        .from(document.getElementById("accessibility-test-results"))
        .set({
          margin: 0.5,
          filename: `accessibility-report-${formData.url.replace(/^https?:\/\//, '').replace(/\W/g, '_')}.pdf`,
          image: { type: 'jpeg', quality: 1 },
          html2canvas: {
            scale: 2,
            useCORS: true,
          },
          pagebreak: { mode: ['css', 'legacy'], avoid: ['.pdf-avoid-break'] },
          jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' }
        })
        .save()
        .then(() => setRenderForPDF(false))
        .catch(() => setRenderForPDF(false));
    }, 500);
  };

  const handlePrintPDF = () => {
    setRenderForPDF(true);
    setTimeout(() => {
      const html = document.getElementById("accessibility-test-results")?.innerHTML;
      sessionStorage.setItem("pdfContent", html);
      window.open(accessibility_test_data.site_url + "/pdf-print", "_blank");
      setRenderForPDF(false);
    }, 500);
  };

  // const handlePrintPDF = () => {
  //   const resultEl = document.getElementById("accessibility-test-results");
  //   if (!resultEl) return;

  //   const win = window.open("", "_blank");
  //   if (!win) return;

  //   const htmlContent = `
  //     <!DOCTYPE html>
  //     <html>
  //       <head>
  //         <title>Accessibility Report</title>
  //         <meta charset="utf-8" />
  //         <style>
  //           body {
  //             font-family: Arial, sans-serif;
  //             padding: 40px;
  //             color: #000;
  //           }

  //           .score-bar {
  //             background-color: #ffc107;
  //             height: 32px;
  //             color: white;
  //             font-weight: bold;
  //             text-align: center;
  //             line-height: 32px;
  //             border-radius: 4px;
  //             margin-bottom: 20px;
  //           }

  //           .error { color: #dc3545; }
  //           .alert { color: #ffc107; }
  //           .contrast { color: #0d6efd; }

  //           .accordion-content {
  //             display: block !important;
  //           }

  //           @media print {
  //             .no-print { display: none; }
  //           }
  //         </style>
  //       </head>
  //       <body>
  //         <div id="print-wrapper">
  //           ${resultEl.innerHTML}
  //         </div>
  //       </body>
  //     </html>
  //   `;

  //   win.document.open();
  //   win.document.write(htmlContent);
  //   win.document.close();
  // };


  // Used testing on page load
  // const storePageContentToState = () => {
  //   setLoading(true)
  //   fetchPageContent('https://seooneclick.com/')
  //     .then(pageContent => {
  //       let parser = new DOMParser();
  //       return parser.parseFromString(pageContent, 'text/html');
  //     })
  //     .then((doc) => {
  //       Object.keys(results.categories).map((category) => {
  //         const categoryData = results.categories[category]

  //         Object.values(categoryData.items).map((item) => {
  //           let new_selectors = []

  //           Object.values(item.selectors).map((selector) => {
  //             let fetchElementString = doc.querySelector(selector)?.outerHTML

  //             new_selectors.push(fetchElementString)
  //           })

  //           // Push an array to object
  //           item.new_selectors = new_selectors
  //         })
  //       })
  //       setNewResults(results)
  //     })
  //     .finally(() => {
  //       setLoading(true)
  //     })
  // }

  // useEffect(() => {
  //   storePageContentToState()
  // }, [newResults, results]);

  const renderForm = () => {
    return (
      <>
        <form id="form-wave-accessibility-test" onSubmit={handleSubmit}>
          <div className='row d-flex align-items-center mb-xl-4'>
            <div className='col-xl-6 mb-4 mb-xl-0' ref={submittedUrl}>
              <InputField
                id="firstName"
                name="firstName"
                type="text"
                label={t('First Name')}
                placeholder={t('Your First Name')}
                value={formData.firstName}
                error={errors.firstName}
                onChange={handleChange}
              />
            </div>
            <div className='col-xl-6 mb-4 mb-xl-0' ref={submittedUrl}>
              <InputField
                id="lastName"
                name="lastName"
                type="text"
                label={t('Last Name')}
                placeholder={t('Your Last Name')}
                value={formData.lastName}
                error={errors.lastName}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className='row d-flex align-items-center mb-4'>
            <div className='col-xl-6 mb-4 mb-xl-0'>
              <InputField
                id="email"
                name="email"
                type="email"
                label={t('Email')}
                placeholder={t('example@email.com')}
                value={formData.email}
                error={errors.email}
                onChange={handleChange}
              />
            </div>
            <div className='col-xl-6'>
              <PhoneInputField
                id="phone"
                name="phone"
                label={t('Phone Number')}
                error={errors.phone}
                ref={itiRef}
              />
            </div>
          </div>
          <div className='row d-flex align-items-center mb-4'>
            <div className='col-xl-6 mb-4 mb-xl-0'>
              <InputSelect
                id="agencyOrFreelancer"
                name="agencyOrFreelancer"
                label={t('Are you an agency or a freelancer?')}
                value={formData.agencyOrFreelancer}
                error={errors.agencyOrFreelancer}
                onChange={handleChange}
              />
            </div>
            <div className='col-xl-6'>
              <InputField
                id="url"
                name="url"
                type="text"
                label={t('Website URL')}
                placeholder={t('Website URL')}
                value={formData.url}
                error={errors.url}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className='row mb-4'>
            <div className='col-xl-12'>
              <InputField
                id="help"
                name="help"
                type="text"
                label={t('How can we help you?')}
                placeholder=""
                value={formData.help}
                error={errors.help}
                onChange={handleChange}
              />
            </div>
          </div>

          <div role="alert" className="alert alert-primary mb-5 text-smaller">
            {t('By providing your email, you choose to receive occasional updates and important accessibility information from us.')}
            <br />
            {t('You can opt out at any time.')}
          </div>
          <div className='d-flex justify-content-center'>
            <button type="submit" ref={submitRef} className='btn btn-primary'>{t('Get a Free Audit')}</button>
          </div>
        </form>
        {error && <ErrorNotification message={error} className="alert alert-warning" role="alert" />}
      </>
    )
  }

  const renderResults = () => {
    return (
      <>
        {!loading && (
          <>
            {/* <div className='d-flex justify-content-end mb-4 mb-xl-6'>
              <button className="btn" onClick={handleDownloadPDF}>
                Download PDF Report
              </button>
            </div> */}
            <div className='d-flex justify-content-end mb-4 mb-xl-6'>
              <button className="btn" onClick={handleDownloadPDF} disabled={renderForPDF}>
                {renderForPDF ? (
                  <>
                    <svg width="16" height="16" viewBox="0 0 50 50" className="me-2" style={{ verticalAlign: 'text-bottom' }} aria-hidden="true">
                      <circle cx="25" cy="25" r="20" fill="none" stroke="currentColor" strokeWidth="5" strokeLinecap="round" strokeDasharray="80 50">
                        <animateTransform attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.8s" repeatCount="indefinite" />
                      </circle>
                    </svg>
                    {t('Generating PDF...')}
                  </>
                ) : (
                  t('Download PDF Report')
                )}
              </button>
            </div>
          </>
        )}

        <div id="accessibility-test-results">
          {
            (loading) ? (
              <ListPlaceholder className="w-100 h-100" /> // Show loading indicator while data is being fetched
            ) : (
              <>
                <div className='text-center mb-4 mb-xl-6'>
                  <h2 className="modal-title fs-3 p-0 m-0 border-0">{t('Website Accessibility Test Results')}</h2>
                  <h3 className='fw-normal fs-4 mb-0'>{t('website url:')} <span className='text-secondary'>{formData.url}</span></h3>
                </div>
                <RenderFinalScore finalScore={finalScore}></RenderFinalScore>
                {!renderForPDF && <CalendlyCTA />}
                {/* <CalendlyCTA /> */}
                <RenderResults results={newResults.categories} loading={loading} forPDF={renderForPDF} totalScannedElements={newResults.statistics?.allitemcount} />
              </>
            )
          }
        </div>
      </>
    );
  };

  return (
    <>
      <button type="submit" className='btn btn-primary' data-bs-toggle="modal"
        data-bs-target="#modal-accessibility-test">{t('Test My Website')}</button>
      <div className="modal modal-lg fade" id="modal-accessibility-test"
        aria-labelledby="modal-accessibility-test-label">
        <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header pb-0 border-0">
              {
                loading ?
                  <h2 className="modal-title fs-3 p-0 m-0 border-0" id="modal-accessibility-test-label">{t('Loading your results...')}</h2> :
                  !finalScore ?
                    <h2 className="modal-title fs-3 p-0 m-0 border-0" id="modal-accessibility-test-label">{t('Test Your Website')}</h2> : false
              }
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body text-start p-4 px-xl-4 pb-xl-7">
              {!hideFormOnSubmit ? renderForm() : ''}
              {hideFormOnSubmit ? renderResults() : ''}
            </div>
          </div>
        </div>
      </div>
      <CalendlyModal />
    </>
  );
};

export default WaveAccessibilityTest;
